<template>
  <div class="other">
    <drag-modal :visible="$store.state.dislog.Laysuit" @cancel="reset" title="案件信息" width="584px">
      <a-form-model ref="newforms" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
        <a-form-model-item label="案件类型" prop="agent_model">
          <a-select show-search v-model="form.cause_type" placeholder="请选择案件类型" :disabled="form.id?true:false">
            <a-select-option
              v-for="d in [{ id: 1, tit: '诉讼', disabled: false }, { id: 2, tit: '调解', disabled: !$common.AccAUTH($store.state.Debinfo.info.accuser.id, 'arbitrate:index') }]"
              :key="d.id" :disabled="d.disabled">
              {{ d.tit }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="form.cause_type == 1 ? '诉讼立案代理人' : '被申请人代理人'" prop="agent">
          <a-input v-model="form.agent" />
        </a-form-model-item>
        <a-form-model-item label="执行立案代理人">
          <a-input v-model="form.exec_la_agent" />
        </a-form-model-item>
        <a-form-model-item label="执行代理人">
          <a-input v-model="form.exec_agent" />
        </a-form-model-item>
        <a-form-model-item :label="form.cause_type == 1 ? '原告' : '申请人'" prop="accuser_id">
          <a-select show-search v-model="form.accuser_id" placeholder="请选择"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode" @blur="leaveAcc" @change="setChinaId"
            :allowClear="true" :default-active-first-option="false" :show-arrow="false" :filter-option="false"
            :not-found-content="null" @search="handleSearch">
            <a-select-option v-for="d in accuser" :key="d.id">
              <Normap :tit='d.title'>{{ d.title }}</Normap>
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="业务来源" prop="team_id">
          <a-select show-search v-model="form.team_id" placeholder="请选择业务来源"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-if="form.accuser_id">
            <a-select-option v-for="d in teamList" :key="d.team.id">
              {{ d.team.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="证件号码" v-if="form.chinaid">
          {{ form.chinaid }}
        </a-form-model-item>
        <a-form-model-item :label="form.cause_type == 1 ? '被告' : '被申请人'" prop="debtor_ids">
          <a-select v-model="form.debtor_ids" placeholder="请选择" show-search mode="multiple"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode" :filter-option="filterOption">
            <a-select-option v-for="i in debtorAll" :key="i.id">
              {{ i.realname }}
            </a-select-option>
          </a-select> 
        </a-form-model-item>
        <a-form-model-item label="法院地区：" prop="court">
          <a-cascader :options="options" placeholder="请选择" change-on-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            :field-names="{ label: 'full_name', value: 'id', children: 'more' }" v-model="form.court" @change="
              seachCourtList(form.court)
            form.court_id = null
              " />
        </a-form-model-item>
        <a-form-model-item label="管辖法院" prop="court_id">
          <a-select show-search v-model="form.court_id" placeholder="请选择法院"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode" :allowClear="true"
            :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null">
            <a-select-option v-for="d in courtList" :key="d.id">
              <Normap :tit='d.title'>{{ d.title }}</Normap>
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="调解机构地区：" prop="arb" v-if="form.cause_type == 2">
          <a-cascader :options="options" placeholder="请选择" change-on-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            :field-names="{ label: 'full_name', value: 'id', children: 'more' }" v-model="form.arb" @change="
              seachArbList(form.arb)
            form.arb_org_id = null
              " />
        </a-form-model-item>
        <a-form-model-item label="调解机构" prop="arb_org_id" v-if="form.cause_type == 2">
          <a-select show-search v-model="form.arb_org_id" placeholder="请选择调解机构"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode" :allowClear="true"
            :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null">
            <a-select-option v-for="d in arbList" :key="d.id">
              {{ d.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="贷款机构" prop="bank_id">
          <a-select show-search v-model="form.bank_id" placeholder="请选择贷款机构"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode" :allowClear="true"
            :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null">
            <a-select-option v-for="d in bank" :key="d.id">
              {{ d.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="form.cause_type == 1 ? '诉讼案号' : '调解案号'" prop="no">
          <a-input v-model="form.no" :disabled="true" />
        </a-form-model-item>

        <a-form-model-item label="本金" prop="capital">
          <a-input v-model="form.capital" placeholder="请输入本金" min="1" @change="handleAmountInput"></a-input>
        </a-form-model-item>
        <a-form-model-item label="利息" prop="used_fee">
          <a-input v-model="form.used_fee" placeholder="请输入利息" @change="handleFeeInput"></a-input>
        </a-form-model-item>
        <a-form-model-item label="本案代偿时间" prop="compensation_time" v-if="form.cause_type == 1">
          <!-- <a-select v-model='form.is_full_pay'>
            <a-select-option :key="1">不详</a-select-option>
            <a-select-option :key="2">是</a-select-option>
            <a-select-option :key="3">否</a-select-option>
          </a-select> -->
          <a-date-picker v-model="form.compensation_time" placeholder="请选择操作时间"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode" :disabled="isEdit('compensation_time')"
            :class="{ yellow: isEdit('compensation_time') }" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" type="date"
            style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item label="是否追究拒执" prop="is_payee_cancel">
          <a-select v-model="form.is_payee_cancel" :getPopupContainer="(triggerNode) => triggerNode.parentNode">
            <a-select-option :key="1">否</a-select-option>
            <a-select-option :key="4">准备中</a-select-option>
            <a-select-option :key="2">刑事自诉</a-select-option>
            <a-select-option :key="3">检察院公诉</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="是否为重审案件" prop="is_retrial" v-if="form.cause_type == 1">
          <a-select v-model="form.is_retrial" :getPopupContainer="(triggerNode) => triggerNode.parentNode">
            <a-select-option :key="1">是</a-select-option>
            <a-select-option :key="2">否</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="是否留置车辆 " prop="is_retain_car">
          <a-select v-model="form.is_retain_car" :getPopupContainer="(triggerNode) => triggerNode.parentNode">
            <!-- <a-select-option :key="0">不详</a-select-option> -->
            <!-- <a-select-option :key="1">是</a-select-option> -->
            <a-select-option :key="2">否</a-select-option>
            <a-select-option :key="3">法院扣押</a-select-option>
            <a-select-option :key="4">{{ form.cause_type == 1 ? '原告' : '申请人' }}自行留置</a-select-option>
            <a-select-option :key="5">{{ form.cause_type == 1 ? '被告' : '被申请人' }}主动交付</a-select-option>
            <a-select-option :key="6">{{ form.cause_type == 1 ? '原告' : '申请人' }}提供线索由法院扣押</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="是否优先受偿" prop="is_first_compensation">
          <a-select v-model="form.is_first_compensation" :getPopupContainer="(triggerNode) => triggerNode.parentNode">
            <a-select-option :key="0">不详</a-select-option>
            <a-select-option :key="1">支持</a-select-option>
            <a-select-option :key="2">未支持</a-select-option>
            <a-select-option :key="3">未主张</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="车辆是否首封" prop="is_first_ban">
          <a-select v-model="form.is_first_ban" :getPopupContainer="(triggerNode) => triggerNode.parentNode">
            <a-select-option :key="0">不详</a-select-option>
            <a-select-option :key="1">是</a-select-option>
            <a-select-option :key="2">否</a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- :disabled='isEdit("cause_reason_id")' :class='{"yellow":isEdit("cause_reason_id")}' -->
        <a-form-model-item label="案由" prop="cause_reason_id">
          <a-select show-search v-model="form.cause_reason_id" placeholder="请选择案由"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode">
            <a-select-option v-for="d in cause_reason" :key="d.id">
              {{ d.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- <div v-if='!form.id'>
          <a-form-model-item label="特殊备注" prop="note">
            <a-input v-model='form.note' placeholder='请输入特殊备注' type="textarea" style="height:80px;"></a-input>
          </a-form-model-item>
        </div>
        <div v-else>
          <a-form-model-item label="特殊备注" prop="note" v-if='$store.state.cause.invaild==0 ? $common.AUTH("cause:innerComment:edit"):$common.AUTH("cause:invaild:innerComment:edit")'>
            <a-input v-model='form.note' placeholder='请输入特殊备注' type="textarea" style="height:80px;"></a-input>
          </a-form-model-item>
        </div> -->
        <a-form-model-item :wrapper-col="{ span: 16, offset: 6 }">
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
            <a-button type="primary" style="margin-right: 20px; width: 148px">保存</a-button>
          </a-popconfirm>
          <a-button style="background: #b2c9e1; color: #fff; width: 148px" @click="reset">关闭</a-button>
        </a-form-model-item>
      </a-form-model>
    </drag-modal>
  </div>
</template>
<script>
import { accuseList, debtorAll, reasonList } from '@/server/api'
import { getDirectory, bankList, arbOrg } from '@/server/directory'
import city from '@/assets/js/city.json'
import { CaseAdd, CaseEdit } from '@/server/debtor'
import { citySort } from '@/assets/js/unit'
import Validator from "@/assets/js/yz.js"
function isValidDate(date) {
  return date instanceof Date && !isNaN(date.getTime())
}
export default {
  name: 'Laysuit',
  props: {
    info: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      Validator,
      bank: [],
      options: citySort(city),
      visible: false,
      audit: [],
      rules: {
        bank_id: [
          { required: true, message: '请选择贷款机构', trigger: 'change' },
        ],
        //   agent_model: [{ required: true, message: '请选择单独维护', trigger: 'change' }],
        accuser_id: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        no: [{ required: false, message: '请输入案号', trigger: 'blur' }],
        debtor_ids: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        agent: [
          { required: false, message: '请输入诉讼立案代理人', trigger: 'blur' },
        ],
        court_id: [{ required: true, message: '请选择法院', trigger: 'blur' }],
        court: [
          { required: true, message: '请选择法院地区', trigger: 'change' },
        ],
        //     is_full_pay: [{ required: true, message: '请选择是否全额 代偿', trigger: 'change' }],
        capital: [{ required: true, validator: Validator.amount.bind(this), trigger: 'blur' }],
        used_fee: [{ required: false, validator: Validator.amount.bind(this), trigger: 'blur' }],
        cause_reason_id: [
          { required: true, message: '请选择案由', trigger: 'change' },
        ],
        team_id: [
          { required: true, message: '请选择业务来源', trigger: 'change' },
        ],
      },
      debtorAll: [], //被告 债务人+其他债务人列表
      accuser: [], //原告列表
      cause_reason: [],
      arbList: [],
      courtList: [], //法院
      data: {
        limit: 50,
        page: 1,
        title: null,
      },
      reasonData: {
        limit: 50,
        page: 1,
        title: null,
      },
      form: {
        arb_org_id: '',
        exec_la_agent: '',
        //    agent_model: 2,
        bank_id: '',
        cause_reason_id: null,
        // is_full_pay: 1,
        compensation_time: '',
        exec_agent: '',
        court: [],
        court_type: 1,
        team_id: null,
        id: null, //修改时使用
        debtor_id: this.$route.params.id,
        accuser_id: null,
        agent: null,
        court_id: '',
        debtor_ids: [],
        no: null,
        used_fee: null,
        capital: 0,
        //   note: null,
        chinaid: null,
        is_payee_cancel: null,
        is_retrial: null,
        is_retain_car: 2,
        is_first_compensation: null,
        is_first_ban: null,
      },
    }
  },
  computed: {
    teamList() {
      if (this.form.accuser_id) {
        return this.accuser.filter((ele) => {
          return ele.id == this.form.accuser_id
        })[0].team
      }
    },
  },
  watch: {
    info: {
      handler(newVal) {
        if (newVal.accuser_id) {
          this.form.bank_id = newVal.bank ? newVal.bank.id : null
          this.form.exec_la_agent = newVal.exec_la_agent
          //     this.form.agent_model = newVal.agent_model
          this.form.cause_reason_id = newVal.reason && newVal.reason.id
          this.form.id = newVal.id
          this.form.accuser_id = newVal.accuser_id
          this.form.agent = newVal.agent

          this.form.debtor_ids = newVal.accused.map((ele) => {
            return ele.id
          })
          this.form.no = newVal.id ? newVal.no : null
          this.form.used_fee = newVal.used_fee == 0 ? null : newVal.used_fee / 100
          // this.form.note = newVal.note
          this.setChinaId(newVal.accuser_id)
          this.form.team_id = newVal.team_id
          //   this.form.is_full_pay = newVal.is_full_pay
          this.form.compensation_time = isValidDate(
            new Date(newVal.compensation_time)
          )
            ? newVal.compensation_time
            : ''
          this.form.is_payee_cancel = newVal.is_payee_cancel

          this.form.is_retain_car = newVal.is_retain_car
          this.form.is_first_compensation = newVal.is_first_compensation
          this.form.is_first_ban = newVal.is_first_ban
          this.form.capital = newVal.capital / 100
          this.form.exec_agent = newVal.exec_agent
          this.form.cause_type = newVal.cause_type
          this.audit = newVal.audit
          this.form.court = newVal.courte
            ? [
              newVal.courte.province_id,
              newVal.courte.city_id,
              newVal.courte.area_id,
            ]
            : [110000]
          this.form.court_id = newVal.courte ? newVal.courte.id : ''
          this.seachCourtList(this.form.court)
          if (newVal.cause_type == 2) {
            const arb = [newVal.arb_org.province_id, newVal.arb_org.city_id, newVal.arb_org.area_id].filter(ele => { return ele })
            this.form.arb = arb
            this.seachArbList(arb)
            this.form.arb_org_id = newVal.arb_org.id
            this.form.is_retrial = null
          } else {
            this.form.is_retrial = newVal.is_retrial
          }
        } else {
          this.form = {
            arb_org_id: '',
            bank_id: '',
            exec_la_agent: '',
            //      agent_model: 2,
            cause_reason_id: '',
            is_payee_cancel: 1,
            is_retrial: 2,
            is_retain_car: 2,
            is_first_compensation: 0,
            is_first_ban: 0,
            //      is_full_pay: 1,
            compensation_time: '',
            court: [],
            id: null, //修改时使用
            debtor_id: this.$route.params.id,
            accuser_id: null,
            agent: null,
            team_id: null,
            court_id: '',
            cause_type: 1,
            used_fee: null,
            debtor_ids: [],
            no: null,
            exec_agent: null,
            //   note: null,
            capital: '',
          }
          this.audit = []
        }
      },
      immediate: true,
    },
  },
  created() {
    this.getAccInit()
    this.causeList()
    debtorAll({ id: this.form.debtor_id }).then((e) => {
      this.debtorAll = e.list
    })
    bankList({ limit: 1000 }).then((e) => {
      this.bank = e.list
    })
  },
  methods: {
    handleAmountInput(e) {
      const invalidSymbols = /[^0-9.]/g;
      if (invalidSymbols.test(e.target.value)) {
        this.form.capital = ''
        return;
      }else{
        const value = e.target.value;
        e.target.value = Validator.formatAmount ? Validator.formatAmount(value) : value;
      }
    },
    handleFeeInput(e){
      const invalidSymbols = /[^0-9.]/g;
      if (invalidSymbols.test(e.target.value)) {
        this.form.used_fee = ''
        return;
      }else{
        const value = e.target.value;
        e.target.value = Validator.formatAmount ? Validator.formatAmount(value) : value;
      }
    },
    formKey() {

    },
    isEdit(val) {
      let bool =
        this.audit.filter((ele) => {
          return val.split(',').indexOf(ele.field) >= 0
        }).length > 0
          ? true
          : false
      return bool
    },
    setChinaId(e) {
      this.form.team_id = null
      let selected = this.accuser.find((ele) => {
        return ele.id == e
      })
      if (selected) {
        this.form.chinaid = selected.chinaid
      }
    },
    confirm() {
      let form = JSON.parse(JSON.stringify(this.form))
      this.$refs.newforms.validate((valid) => {
        form.capital = (form.capital * 100).toFixed(0)
        form.used_fee = (form.used_fee * 100).toFixed(0)
        if (form.cause_type == 2) {
          delete form.arb
          delete form.is_retrial
        } else {
          delete form.arb
          delete form.arb_org_id
        }
        if (valid) {
          if (form.id) {
            //修改
            delete form.debtor_id
            CaseEdit(form).then((e) => {
              this.$message.success({ content: '修改成功', key: 'updatable' })
              this.$store.dispatch('Debinfo/getInfo', {
                id: this.$route.params.id,
              })
              this.$store.dispatch('Case/getlist', {
                debtor_id: this.$route.params.id,
              })
              this.$parent.$parent.init(form.id)
              this.$store.dispatch('openkey', { key: 'Laysuit', by: false })
              //    window.history.go(0)
            })
          } else {
            delete form.id
            CaseAdd(form).then((e) => {
              this.$message.success({ content: '新增成功', key: 'updatable' })
              window.history.go(0)
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    reset() {

      this.$store.dispatch('openkey', { key: 'Laysuit', by: false })
      this.$refs.newforms.resetFields()
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },

    seachCourtList(val) {
      //搜索法院
      let province_id = val[0],
        city_id = val.length > 1 ? val[1] : '',
        area_id = val.length > 2 ? val[2] : ''
      getDirectory({
        province_id: province_id,
        city_id: city_id,
        area_id: area_id,
      }).then((e) => {
        this.courtList = e.list
      })
    },
    seachArbList(val) {
      //搜索法院
      let province_id = val[0],
        city_id = val.length > 1 ? val[1] : '',
        area_id = val.length > 2 ? val[2] : ''
      arbOrg({
        province_id: province_id,
        city_id: city_id,
        area_id: area_id,
      }, 'index').then((e) => {
        this.arbList = e.list
      })
    },
    getAccInit() {
      //获取
      accuseList(this.data).then((e) => {
        this.accuser = e.list
      })
    },
    leaveAcc() {
      if (!this.form.accuser_id) {
        this.data.title = null
        this.getAccInit()
      }
    },
    async handleSearch(name) {
      this.data.title = name
      await this.getAccInit()
    },
    causeList() {
      reasonList(this.reasonData).then((e) => {
        this.cause_reason = e.list
      })
    },
    // leaveCause() {
    //   if (!this.form.accuser_id) {
    //     this.reasonData.title = null
    //     this.causeList();
    //   }
    // },
    // async causeSearch(name) {
    //   this.reasonData.title = name;
    //   await this.causeList();
    // },
  },
  components: {},
}
</script>
<style lang="less">
.yellow .ant-select-selection,
.yellow.ant-calendar-picker {
  border: 1px solid #ff9800 !important;
  opacity: 1;
  color: #ccc;
  /* border: 0 none; */
  background: none;
  border-radius: 4px;
}

/deep/ .ant-form-item-control-wrapper {
  position: relative;
}
</style>
